var _rect, _rect2, _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoriesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 144,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5149,
    y: 17.548,
    width: 109.962,
    height: 109.032,
    rx: 54.516,
    fill: "url(#paint0_linear_2037_286)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5149,
    y: 17.548,
    width: 109.962,
    height: 109.032,
    rx: 54.516,
    stroke: "#CB97FF",
    strokeWidth: 1.40385
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.0581 81.6945L72.4956 94.2687L50.9331 81.6945C50.5062 81.4819 50.0143 81.44 49.5576 81.5773C49.1009 81.7147 48.7136 82.0208 48.4747 82.4336C48.2358 82.8464 48.1631 83.3346 48.2715 83.7991C48.3799 84.2635 48.6612 84.6692 49.0581 84.9336L71.5581 98.0586C71.8448 98.2257 72.1708 98.3138 72.5026 98.3138C72.8345 98.3138 73.1605 98.2257 73.4472 98.0586L95.9472 84.9336C96.1633 84.8113 96.353 84.6473 96.5052 84.4511C96.6574 84.255 96.7691 84.0305 96.8339 83.7908C96.8987 83.5512 96.9152 83.301 96.8826 83.0548C96.8499 82.8087 96.7686 82.5715 96.6436 82.357C96.5185 82.1425 96.352 81.955 96.1539 81.8054C95.9557 81.6558 95.7299 81.547 95.4893 81.4853C95.2488 81.4237 94.9984 81.4104 94.7527 81.4463C94.5071 81.4822 94.2709 81.5666 94.0581 81.6945Z",
    fill: "url(#paint1_linear_2037_286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0581 70.4445L72.4956 83.0187L50.9331 70.4445C50.5062 70.2319 50.0143 70.19 49.5576 70.3273C49.1009 70.4647 48.7136 70.7709 48.4747 71.1836C48.2358 71.5964 48.1631 72.0846 48.2715 72.5491C48.3799 73.0135 48.6612 73.4192 49.0581 73.6836L71.5581 86.8086C71.8448 86.9757 72.1708 87.0638 72.5026 87.0638C72.8345 87.0638 73.1605 86.9757 73.4472 86.8086L95.9472 73.6836C96.1633 73.5613 96.353 73.3973 96.5052 73.2011C96.6574 73.005 96.7691 72.7805 96.8339 72.5408C96.8987 72.3012 96.9152 72.051 96.8826 71.8048C96.8499 71.5587 96.7686 71.3215 96.6436 71.107C96.5185 70.8925 96.352 70.705 96.1539 70.5554C95.9557 70.4058 95.7299 70.297 95.4893 70.2353C95.2488 70.1737 94.9984 70.1604 94.7527 70.1963C94.5071 70.2323 94.2709 70.3166 94.0581 70.4445Z",
    fill: "url(#paint2_linear_2037_286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0581 62.4336L71.5581 75.5586C71.8448 75.7257 72.1707 75.8138 72.5026 75.8138C72.8345 75.8138 73.1604 75.7257 73.4471 75.5586L95.9471 62.4336C96.2302 62.2684 96.465 62.032 96.6282 61.7478C96.7914 61.4637 96.8773 61.1417 96.8773 60.814C96.8773 60.4863 96.7914 60.1644 96.6282 59.8802C96.465 59.596 96.2302 59.3596 95.9471 59.1945L73.4471 46.0695C73.1604 45.9023 72.8345 45.8142 72.5026 45.8142C72.1707 45.8142 71.8448 45.9023 71.5581 46.0695L49.0581 59.1945C48.775 59.3596 48.5402 59.596 48.377 59.8802C48.2138 60.1644 48.1279 60.4863 48.1279 60.814C48.1279 61.1417 48.2138 61.4637 48.377 61.7478C48.5402 62.032 48.775 62.2684 49.0581 62.4336Z",
    fill: "url(#paint3_linear_2037_286)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.495 72.1329C130.495 103.956 104.531 129.759 72.4961 129.759C40.4614 129.759 14.4972 103.956 14.4972 72.1329C14.4972 40.3095 40.4614 14.5064 72.4961 14.5064C104.531 14.5064 130.495 40.3095 130.495 72.1329Z",
    stroke: "url(#paint4_linear_2037_286)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.135 72.064C135.135 106.434 107.093 134.301 72.4957 134.301C37.8983 134.301 9.85662 106.434 9.85662 72.064C9.85662 37.6942 37.8983 9.82684 72.4957 9.82684C107.093 9.82684 135.135 37.6942 135.135 72.064Z",
    stroke: "url(#paint5_linear_2037_286)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.775 71.9952C139.775 108.911 109.656 138.843 72.4958 138.843C35.3356 138.843 5.21648 108.911 5.21648 71.9952C5.21648 35.079 35.3356 5.14739 72.4958 5.14739C109.656 5.14739 139.775 35.079 139.775 71.9952Z",
    stroke: "url(#paint6_linear_2037_286)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.415 71.9265C144.415 111.389 112.219 143.385 72.4959 143.385C32.773 143.385 0.576347 111.389 0.576347 71.9265C0.576347 32.4638 32.773 0.467949 72.4959 0.467949C112.219 0.467949 144.415 32.4638 144.415 71.9265Z",
    stroke: "url(#paint7_linear_2037_286)",
    strokeOpacity: 0.5,
    strokeWidth: 0.935897
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2037_286",
    x1: 72.4957,
    y1: 16.8461,
    x2: 72.4957,
    y2: 127.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8547F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2037_286",
    x1: 72.5606,
    y1: 81.4266,
    x2: 72.5606,
    y2: 98.3138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2037_286",
    x1: 72.5606,
    y1: 70.1766,
    x2: 72.5606,
    y2: 87.0638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2037_286",
    x1: 72.5026,
    y1: 45.8142,
    x2: 72.5026,
    y2: 75.8138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2037_286",
    x1: 14.0293,
    y1: 72.1329,
    x2: 128.615,
    y2: 72.1329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2037_286",
    x1: 9.38867,
    y1: 72.064,
    x2: 133.069,
    y2: 72.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2037_286",
    x1: 4.74854,
    y1: 71.9952,
    x2: 137.523,
    y2: 71.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2037_286",
    x1: 0.1084,
    y1: 71.9265,
    x2: 141.977,
    y2: 71.9265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(42.4956 42.064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesLogo);
export default __webpack_public_path__ + "static/media/categoriesLogo.c5efd9f30a5683147a06d87cace5f1ae.svg";
export { ForwardRef as ReactComponent };